<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-12">
        <div class="row justify-content-center mb-4">
          <img src="@/assets/images/postgreSQL.png" width="12%" alt="" />
        </div>
        <div class="row justify-content-center">
          <h1>O que é?</h1>
        </div>
        <p class="lead">
          PostgreSQL é um poderoso sistema de banco de dados relacional de
          código aberto com mais de 30 anos de desenvolvimento ativo que lhe
          rendeu uma forte reputação de confiabilidade, robustez de recursos e
          desempenho.
        </p>

        <div class="row justify-content-center">
          <h1>Por que utilizar?</h1>
        </div>
        <p class="lead">
          Quais são as maiores vantagens do PostgreSQL? Ele é e sempre foi
          grátis e OpenSource o que dá mais confiança de que continuará assim,
          diferente do MySQL por exemplo. O PostgreSQL também tem uma infinidade
          de recursos, isso se dá porque ele é OpenSource, o que significa que
          qualquer um pode desenvolver uma função nova.
        </p>
        <p class="lead">
          Conta também com miliões de usuários por todo o mundo e mais de
          seiscentos contribuintes que mantém o projeto atualizado.
        </p>
        <div class="row justify-content-center mb-4">
          <img
            class="img-shadow"
            src="@/assets/images/postgres.png"
            width="60%"
            alt=""
          />
        </div>

        <div class="col-sm-12 mt-5">
          <div class="row justify-content-center">
            <h1>Onde baixar?</h1>
          </div>
          <p class="lead">
            Você pode realizar o download do Vue no site oficial ->
            <a target="_blank" href="https://www.postgresql.org/"
              >https://www.postgresql.org/</a
            >. Lá você também pode encontrar notas de atualização, integrações
            de componentes e muito mais.
          </p>
        </div>
      </div>
    </div>

    <div class="text-center mt-5">
      <base-button type="primary" class="my-4" @click="scrollTop"
        >Voltar ao topo</base-button
      >
    </div>
  </div>
</template>

<script>
import { scrollTop } from "@/global";

export default {
  name: "postgres-article",
  methods: { scrollTop: scrollTop },
};
</script>

<style>
</style>